export const LANGS = ['engb', 'id', 'zh', 'th'];
